<template>
    <section class="dashboard-component unacknowledged-package-list two-wide-mobile" v-if="packages.length">
        <section class="flex flex-row">
            <heading :no-margin="true" size="medium">Unacknowledged Packages</heading>
            <div class="ml-auto">
                <ui-button-new :small="true" @click.prevent="markAllPackagesAsViewed()">Mark Packages Viewed</ui-button-new>
            </div>
        </section>
        <p>You have been recently added to the following works packages:</p>
        <ul>
            <li v-for="packageItem in packages">
                <a :href="packageItem._links.classic.view" class="text-brand hover:text-brand-light"><strong>{{ packageItem.project }}:</strong> {{ packageItem.name }}</a>
            </li>
        </ul>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                packages: []
            }
        },
        computed: {},
        watch: {},
        methods: {
            markAllPackagesAsViewed(){
                var that = this;
                this.packages = [];

                axios.put(route('api.v1.packages.mark-all-viewed'))
                    .then(response => {
                        that.getPackages();
                    });
            },
            getPackages() {
                var that = this;
                this.packages = [];

                axios.get(route('api.v1.users.relevant-unacknowledged-packages'))
                    .then(response => {
                        that.packages = response.data.data;
                    });
            }
        },
        mounted() {
            this.getPackages();
        }
    }
</script>